(() => {
  const roots = new WeakSet();
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = window.matchMedia('(min-width: 1100.01px)');
  let activeLayer;
  let cleanupTimer;
  let chatButton;
  let alignmentFrame;

  function alignCheckout() {
    alignmentFrame = undefined;
    document.querySelectorAll('[data-typelab-configurator]').forEach(raiseCheckout);
    const widget = document.getElementById('tidio-chat');
    const button = widget?.shadowRoot?.querySelector('#button-body') || widget?.querySelector('#button-body');
    if (!button) return;
    const rect = button.getBoundingClientRect();
    if (rect.width <= 0 || rect.height <= 0) return;
    if (document.querySelector('[data-typelab-configurator]')) widget.style.setProperty('z-index', '2147483500', 'important');
    const leftSide = rect.left + rect.width / 2 < window.innerWidth / 2;
    document.querySelectorAll('[data-typelab-configurator]').forEach(root => {
      root.style.setProperty('--kbd-chat-bottom', `${Math.max(0, window.innerHeight - rect.bottom)}px`);
      root.style.setProperty('--kbd-chat-height', `${rect.height}px`);
      root.style.setProperty('--kbd-chat-radius', getComputedStyle(button).borderRadius);
      root.style.setProperty('--kbd-checkout-left', leftSide ? `${rect.right + 12}px` : '12px');
      root.style.setProperty('--kbd-checkout-right', leftSide ? '12px' : `${window.innerWidth - rect.left + 12}px`);
      root.style.setProperty('--kbd-checkout-desktop-left', leftSide ? 'auto' : '24px');
      root.style.setProperty('--kbd-checkout-desktop-right', leftSide ? '24px' : 'auto');
    });
    if (chatButton !== button) {
      chatButton = button;
      new ResizeObserver(scheduleAlignment).observe(button);
      if (widget.shadowRoot) new MutationObserver(scheduleAlignment).observe(widget.shadowRoot, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'style'] });
    }
  }

  function scheduleAlignment() {
    if (alignmentFrame === undefined) alignmentFrame = window.requestAnimationFrame(alignCheckout);
  }

  function raiseCheckout(root) {
    const footer = root.querySelector('.typelab-configurator-footer');
    if (!footer) return;
    const shell = root.querySelector('.typelab-configurator-shell');
    const column = root.querySelector('.tl-studio-column');
    const inline = desktop.matches && shell?.querySelector('.tl-build-bar');
    const canPopover = typeof footer.showPopover === 'function' && typeof footer.hidePopover === 'function';
    if (root.hidden || !root.classList.contains('tl-studio') || inline) {
      if (canPopover && footer.matches(':popover-open')) footer.hidePopover();
      footer.removeAttribute('popover');
      if (inline && footer.parentElement !== shell) shell.appendChild(footer);
      return;
    }
    if (column && footer.parentElement !== column) column.appendChild(footer);
    if (canPopover && footer.matches(':popover-open')) footer.hidePopover();
    footer.removeAttribute('popover');
  }

  function clearCelebration() {
    window.clearTimeout(cleanupTimer);
    activeLayer?.remove();
    activeLayer = undefined;
  }

  function celebrate(root) {
    if (motion.matches || document.visibilityState === 'hidden') return;
    clearCelebration();
    const layer = document.createElement('div');
    layer.className = 'kbd-configuration-confetti';
    layer.setAttribute('aria-hidden', 'true');
    const colors = ['#ff477e', '#ff934f', '#ffe66d', '#50d890', '#42c9ff', '#9b72ff', '#f179ef'];
    const preview = desktop.matches ? root.querySelector('.typelab-configurator-preview') : null;
    const bounded = preview && preview.clientWidth > 0 && preview.clientHeight > 0;
    if (bounded) layer.classList.add('kbd-configuration-confetti--preview');
    const width = bounded ? preview.clientWidth : window.innerWidth;
    const height = bounded ? preview.clientHeight : window.innerHeight;
    const count = bounded ? 160 : window.matchMedia('(max-width: 767.98px)').matches ? 140 : 220;
    const fragment = document.createDocumentFragment();
    for (let index = 0; index < count; index += 1) {
      const particle = document.createElement('i');
      particle.textContent = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[Math.floor(Math.random() * 26)];
      const angle = Math.random() * Math.PI * 2;
      const force = 0.35 + Math.random() * 0.65;
      particle.style.setProperty('--confetti-x', `${Math.cos(angle) * width * 0.7 * force}px`);
      particle.style.setProperty('--confetti-y', `${Math.sin(angle) * height * 0.7 * force}px`);
      particle.style.setProperty('--confetti-size', `${14 + Math.random() * 8}px`);
      particle.style.setProperty('--confetti-color', colors[index % colors.length]);
      particle.style.setProperty('--confetti-duration', `${4.2 + Math.random() * 1.2}s`);
      particle.style.setProperty('--confetti-delay', `${Math.random() * 0.12}s`);
      particle.style.setProperty('--confetti-spin', `${Math.random() * 1080 - 540}deg`);
      fragment.appendChild(particle);
    }
    layer.appendChild(fragment);
    (bounded ? preview : document.body).appendChild(layer);
    activeLayer = layer;
    cleanupTimer = window.setTimeout(clearCelebration, 5700);
  }

  function bind(root) {
    if (roots.has(root)) return;
    roots.add(root);
    let wasComplete = false;
    function sync() {
      raiseCheckout(root);
      const complete = root.classList.contains('typelab-selection-complete');
      const notifyMode = root.classList.contains('typelab-notify-mode');
      root.querySelectorAll('[data-typelab-add]').forEach(button => {
        if (notifyMode || button.dataset.typelabBusy) return;
        if (!complete) {
          if (button.textContent !== 'ADD TO CART →') button.textContent = 'ADD TO CART →';
          if (!button.disabled) button.disabled = true;
        } else if (root.classList.contains('typelab-checkout-ready') && !button.dataset.typelabBusy) {
          if (button.textContent !== 'ADD TO CART →') button.textContent = 'ADD TO CART →';
        }
      });
      if (complete && !wasComplete) celebrate(root);
      if (!complete && wasComplete) clearCelebration();
      wasComplete = complete;
    }
    new MutationObserver(sync).observe(root, { attributes: true, attributeFilter: ['class', 'hidden', 'disabled', 'data-typelab-config-state'], childList: true, subtree: true, characterData: true });
    sync();
    scheduleAlignment();
  }

  document.querySelectorAll('[data-typelab-configurator]').forEach(bind);
  new MutationObserver(records => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches('[data-typelab-configurator]')) bind(node);
        node.querySelectorAll('[data-typelab-configurator]').forEach(bind);
      }
    }
    scheduleAlignment();
  }).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('resize', scheduleAlignment, { passive: true });
  desktop.addEventListener('change', clearCelebration);
  window.addEventListener('scroll', scheduleAlignment, { passive: true });
  let attempts = 0;
  const chatStartup = window.setInterval(() => {
    scheduleAlignment();
    if (chatButton || ++attempts >= 30) window.clearInterval(chatStartup);
  }, 500);
  motion.addEventListener('change', event => { if (event.matches) clearCelebration(); });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') clearCelebration();
  });
})();
